import { Injectable } from '@angular/core';

import { Resource } from '@df/catalog/resource';
import { UgcImage } from './ugc-image';

declare module '@df/catalog/resource' {
    interface IResources {
        ugcImage: Resource<UgcImage, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class UgcImageResource extends Resource<UgcImage, number> {
    static override instance = UgcImage;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = true;
}
